export const environment = {
    development: true,
    VERSION: "0.0.101",
    API_DEFINITION_URL: 'https://uat-spriced-cdbu.alpha.simadvisory.com/api/v1/definition',
    API_DATA_URL: 'https://uat-spriced-cdbu.alpha.simadvisory.com/api/v1/data-api',
    API_FLINK_URL:'https://uat-spriced-cdbu.alpha.simadvisory.com/api/v1/flink/platform',
    URL: 'https://excelplugin.spriced.uat-spriced-cdbu.alpha.simadvisory.com',
    AUTH_URL: 'https://auth.simadvisory.com/auth',
    CLIENT: "CHN_SPRICED_NRP_CLIENT",
    REALMS: "SPRICED_NRP",
    PAGESIZE: 5000,
    PUBLISHRECORD: 2500,
    TOTALELEMENTS: 15000,
    VALIDATIONPOPUPLENGTH: 10000,
    RECORD_LIMIT: 50,
    IDP_HINT: 'saml_spriced_uat',
    appUrl:"https://excelplugin.route.uat-spriced-cdbu.alpha.simadvisory.com",
    NX_TML_URL:'https://uat-spriced-cdbu.alpha.simadvisory.com/platform/api/v1/tml',
    NX_EXCEL_SERVICE_URL:'https://uat-spriced-cdbu.alpha.simadvisory.com/api/v1/excel_service/write-csv'
 };
